// В.2.h-rebalance: Военный учёный Бьорк — активка «+2 ХП всем своим
// персонажам этим ходом, MOGUT превышать max_hp».
//
// Без picker'а — массовый эффект на сторону Бьорка.
//
// Эффект:
//   - Для каждого живого союзного персонажа (Герой + юниты): healUnit
//     с allowOverflow=true. Это значит current_hp += 2 без cap'а.
//   - Юнит на полном ХП → 8/6 (overflow +2 сверх max).
//   - Юнит ранен 4/6 → 6/6 (обычный хил, overflow=0).
//   - Overflow держится пока враг не съест эти ХП уроном — таймер не
//     возвращает их.
//
// Триггер Бьорка (registerOnAllyHealedObserver) сам стреляет в случайного
// врага на каждое событие healed своего союзника. Активка лечит до 5
// персонажей → может проложить до 5 ударов. Защита от каскада не нужна:
// applyDamage не зовёт healUnit, цикл не возникает.

import { healUnit } from './heal.js';
import { HERO_ID } from './bork.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

registerImplementedAbility(HERO_ID, 'active');

const LABEL = 'Бьорк (active)';
const SOURCE_ID = 'liv_voennyy_uchenyy_bork_active';
const HEAL = 2;

export { HERO_ID };

// Активка Бьорка не имеет picker'а; список «целей» — для UI/тестов
// (показать кого затронет).
export function getBorkActiveTargets(state, playerIdx) {
  const me = state?.players?.[playerIdx];
  if (!me) return [];
  const out = [];
  if (me.hero && me.hero.hp > 0) out.push(me.hero);
  for (const u of me.unitsOnField()) {
    if (u.type === 'unit' && u.isAlive && u.isAlive()) out.push(u);
  }
  return out;
}

export function borkActiveAvailable(state, playerIdx) {
  const p = state?.players?.[playerIdx];
  if (!p || p.hero?.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  // Доступна всегда пока Герой жив — лечит хотя бы себя (overflow всегда работает).
  return true;
}

export function borkActive(state, playerIdx /*, targetInstanceId — игнорируется */) {
  if (!borkActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  const me = state.players[playerIdx];
  const targets = getBorkActiveTargets(state, playerIdx);
  state.log?.add(
    `✚ ${LABEL} [${me.name}]: +${HEAL} ХП всем своим персонажам (с overflow)`
  );
  for (const t of targets) {
    healUnit(state, t, HEAL, { id: SOURCE_ID, name_ru: LABEL, type: 'action' },
      { allowOverflow: true });
  }
  me.heroActiveUsed = true;
  return { ok: true, healedCount: targets.length };
}
